import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container", "button"]

  connect() {
    this.updateUI()
  }

  updateUI(event) {
    const isChecked = this.inputTarget.checked
    const isDisabled = this.inputTarget.disabled

    // Reset all state classes first
    this.containerTarget.classList.remove(
      'bg-[var(--color-brand-600)]',
      'bg-[#E4E5E8]',
      'bg-[#C9CBD1]',
      'hover:bg-[#4427BF]',
      'cursor-pointer',
      'cursor-not-allowed'
    )

    this.buttonTarget.classList.remove(
      'bg-white',
      'bg-[#F3F4F6]',
      'translate-x-full',
      'translate-x-0'
    )

    // Apply new state classes
    if (isDisabled) {
      // Disabled state
      this.containerTarget.classList.add('bg-[#C9CBD1]', 'cursor-not-allowed')
      this.buttonTarget.classList.add('bg-[#F3F4F6]')
    } else if (isChecked) {
      // Checked state
      this.containerTarget.classList.add('bg-[var(--color-brand-600)]', 'hover:bg-[#4427BF]', 'cursor-pointer')
      this.buttonTarget.classList.add('bg-white')
    } else {
      // Unchecked state
      this.containerTarget.classList.add('bg-[#E4E5E8]', 'cursor-pointer')
      this.buttonTarget.classList.add('bg-white')
    }

    // Update button position
    if (isChecked) {
      this.buttonTarget.classList.add('translate-x-full')
    } else {
      this.buttonTarget.classList.add('translate-x-0')
    }

    // Auto-submit form if this change came from user interaction
    // Skip auto-submit if data-toggle-auto-submit="false" is set
    if (event && event.target === this.inputTarget) {
      const autoSubmit = this.element.dataset.toggleAutoSubmit !== "false"
      const form = this.element.closest('form')
      if (form && autoSubmit) {
        form.requestSubmit()
      }
    }
  }
}
